<template>
  <div class="cancelled-subscription-page">
    <p class="content-title">Subscription Cancelled</p>
    <p class="recommend-section">
      Recommended: Continue your <br />
      progress with parenting guidance.
    </p>
    <option-button class="therapy-option" :is-clickable="false">
      <div class="img-text-section">
        <img
          :src="require(`@/assets/lasting_parenting_icon.svg`)"
          alt="Parenting Guide from Lasting Icon"
          width="85"
          height="85"
        />
        <div class="text">
          <header>Parenting Guide from Lasting</header>
          Raise healthy, resilient kids
        </div>
      </div>

      <cta-button
        type="button"
        :full-width="true"
        :orange="true"
        @click="goToTakeTheQuiz"
        >Take the quiz</cta-button
      >
    </option-button>
  </div>
</template>

<script>
import OptionButton from "@/components/OptionButton";
import CtaButton from "@/components/CtaButton";

export default {
  name: "CancelConfirmationPage",
  components: {
    OptionButton,
    CtaButton,
  },
  methods: {
    goToTakeTheQuiz() {
      window.location = process.env["VUE_APP_LP_QUIZ_LINK"];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables";
@import "@/style/mixins";
@import "@/style/pages/cancel-confirmation";
</style>
